import React from 'react';
import { motion } from 'framer-motion';

const ClientTrust = () => {
  const testimonials = [
    {
      quote: "Namvoro transformed our domain management from chaos to complete control. Their white-glove service is unmatched.",
      company: "Fortune 500 Technology Company",
      role: "Chief Information Officer"
    },
    {
      quote: "The level of security and reliability we've achieved with Namvoro's infrastructure is exactly what our board demanded.",
      company: "Global Financial Services Firm",
      role: "Head of Digital Security"
    },
    {
      quote: "Their discrete, professional approach to brand protection has saved us from multiple potential threats.",
      company: "International Retail Corporation",
      role: "Brand Protection Director"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Trusted by Corporations Around the Globe — Discreetly
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Our clients value confidentiality as much as excellence. Here's what they say about our partnership.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-slate-50 rounded-2xl p-8 relative"
            >
              <div className="text-4xl text-emerald-600 mb-4">"</div>
              <blockquote className="text-slate-700 mb-6 leading-relaxed">
                {testimonial.quote}
              </blockquote>
              <div className="border-t border-slate-200 pt-4">
                <p className="font-semibold text-slate-900">{testimonial.company}</p>
                <p className="text-slate-600 text-sm">{testimonial.role}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="inline-flex items-center space-x-8 bg-slate-50 rounded-2xl px-8 py-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600">500+</div>
              <div className="text-slate-600 text-sm">Domains Protected</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600">99.9%</div>
              <div className="text-slate-600 text-sm">Uptime Achieved</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600">24/7</div>
              <div className="text-slate-600 text-sm">Security Monitoring</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientTrust;